import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxInput, ReduxSwitch } from 'components/FormElements/ReduxForm'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// constants
import { Forms } from 'constants/index'
// utils
import { required } from 'utils/validators'
// views
import { ButtonWrapper, Fields, RolloverSection } from '../views'

export interface IPlanCloneFormData {
  name: string
  includeLinks?: boolean
  months?: number | string
  includeOwners?: boolean
  includeMembers?: boolean
}

interface IIncomingProps {
  hideModal: () => void
}

type IProps = IIncomingProps & InjectedFormProps<IPlanCloneFormData, IIncomingProps>

const PlanCloneForm: React.FC<IProps> = ({ handleSubmit, submitting, hideModal }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Fields>
        <ReduxInput name={'name'} label={'Name'} required validate={required} />
        <ReduxSwitch name={'includeLinks'} label={'Include links'} justifyContent={'space-between'} />
        <ReduxSwitch name={'includeOwners'} label={'Include owners'} justifyContent={'space-between'} />
        <ReduxSwitch name={'includeMembers'} label={'Include members'} justifyContent={'space-between'} />

        <RolloverSection>
          <span>Push dates forward by</span>
          <ReduxInput name={'months'} type={'number'} inputProps={{ min: 0, step: 1 }} />
          <span>months</span>
        </RolloverSection>
      </Fields>

      <ButtonWrapper>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess disabled={submitting}>
          Clone
        </Button>
        <Button type={'button'} onClick={hideModal} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess>
          Cancel
        </Button>
      </ButtonWrapper>
    </form>
  )
}

export default reduxForm<IPlanCloneFormData, IIncomingProps>({
  form: Forms.PLAN_CLONE_FORM,
  enableReinitialize: true
})(PlanCloneForm)
